import React from 'react'
import './styles.css'
import { IStudyPlan } from 'store/modules/studyPlan/types'
import { formatHours } from 'pages/Planning/utils/helpers'

interface NumbersProps {
  plan: IStudyPlan
  percentage: number
  hours: number
  completedSessions: number
  completedCycles: number
  totalSessions: number
}

/**
 * Componente que exibe cards com métricas principais do ciclo
 */
const Numbers: React.FC<NumbersProps> = ({
  plan,
  percentage,
  hours,
  completedSessions,
  completedCycles,
  totalSessions,
}) => {
  return (
    <div className="cycle-section span-3">
      <div className="cycle-numbers-container">
        <div className="cycle-number-card" data-tour="dashboard-metric-cycles">
          <div className="cycle-number-value">{completedCycles}</div>
          <div className="cycle-number-label">CICLO CONCLUÍDO</div>
        </div>

        <div className="cycle-number-card" data-tour="dashboard-metric-hours">
          <div className="cycle-number-value">
            {formatHours(hours)} / {plan.config.cycle.hours.toFixed(1)}h
          </div>
          <div className="cycle-number-label">TEMPO DE ESTUDO</div>
        </div>

        <div className="cycle-number-card" data-tour="dashboard-metric-sessions">
          <div className="cycle-number-value">
            {completedSessions}/{totalSessions}
          </div>
          <div className="cycle-number-label">SESSÕES CONCLUÍDAS</div>
        </div>

        <div className="cycle-number-card" data-tour="dashboard-metric-progress">
          <div className="cycle-number-value">{percentage}%</div>
          <div className="cycle-number-label">PROGRESSO</div>
        </div>
      </div>
    </div>
  )
}

export default Numbers
